// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetPublicTickerALLQuoteId (params?: {}): Promise<Dict>;
    publicGetPublicTickerBaseIdQuoteId (params?: {}): Promise<Dict>;
    publicGetPublicOrderbookALLQuoteId (params?: {}): Promise<Dict>;
    publicGetPublicOrderbookBaseIdQuoteId (params?: {}): Promise<Dict>;
    publicGetPublicTransactionHistoryBaseIdQuoteId (params?: {}): Promise<Dict>;
    publicGetPublicNetworkInfo (params?: {}): Promise<Dict>;
    publicGetPublicAssetsstatusMultichainALL (params?: {}): Promise<Dict>;
    publicGetPublicAssetsstatusMultichainCurrency (params?: {}): Promise<Dict>;
    publicGetPublicWithdrawMinimumALL (params?: {}): Promise<Dict>;
    publicGetPublicWithdrawMinimumCurrency (params?: {}): Promise<Dict>;
    publicGetPublicAssetsstatusALL (params?: {}): Promise<Dict>;
    publicGetPublicAssetsstatusBaseId (params?: {}): Promise<Dict>;
    publicGetPublicCandlestickBaseIdQuoteIdInterval (params?: {}): Promise<Dict>;
    publicGetV1MarketAll (params?: {}): Promise<List>;
    publicGetV1CandlesMinutesUnit (params?: {}): Promise<List>;
    publicGetV1CandlesDays (params?: {}): Promise<List>;
    publicGetV1CandlesWeeks (params?: {}): Promise<List>;
    publicGetV1CandlesMonths (params?: {}): Promise<List>;
    publicGetV1TradesTicks (params?: {}): Promise<List>;
    publicGetV1Ticker (params?: {}): Promise<List>;
    publicGetV1Orderbook (params?: {}): Promise<List>;
    publicGetV1MarketVirtualAssetWarning (params?: {}): Promise<Dict | List>;
    publicGetV1Notices (params?: {}): Promise<Dict | List>;
    publicGetV2FeeInoutCurrency (params?: {}): Promise<Dict>;
    privateGetV1Accounts (params?: {}): Promise<List>;
    privateGetV1OrdersChance (params?: {}): Promise<Dict>;
    privateGetV1Order (params?: {}): Promise<Dict>;
    privateGetV1Orders (params?: {}): Promise<List>;
    privateGetV1Twap (params?: {}): Promise<Dict>;
    privateGetV1Withdraws (params?: {}): Promise<List>;
    privateGetV1WithdrawsKrw (params?: {}): Promise<List>;
    privateGetV1Withdraw (params?: {}): Promise<Dict>;
    privateGetV1WithdrawsChance (params?: {}): Promise<Dict>;
    privateGetV1WithdrawsCoinAddresses (params?: {}): Promise<List>;
    privateGetV1Deposits (params?: {}): Promise<List>;
    privateGetV1DepositsKrw (params?: {}): Promise<List>;
    privateGetV1Deposit (params?: {}): Promise<Dict>;
    privateGetV1DepositsCoinAddresses (params?: {}): Promise<List>;
    privateGetV1DepositsCoinAddress (params?: {}): Promise<Dict>;
    privateGetV1StatusWallet (params?: {}): Promise<Dict | List>;
    privateGetV1ApiKeys (params?: {}): Promise<Dict | List>;
    privatePostInfoAccount (params?: {}): Promise<Dict>;
    privatePostInfoBalance (params?: {}): Promise<Dict>;
    privatePostInfoWalletAddress (params?: {}): Promise<Dict>;
    privatePostInfoTicker (params?: {}): Promise<Dict>;
    privatePostInfoOrders (params?: {}): Promise<Dict>;
    privatePostInfoUserTransactions (params?: {}): Promise<Dict>;
    privatePostInfoOrderDetail (params?: {}): Promise<Dict>;
    privatePostTradePlace (params?: {}): Promise<Dict>;
    privatePostTradeCancel (params?: {}): Promise<Dict>;
    privatePostTradeBtcWithdrawal (params?: {}): Promise<Dict>;
    privatePostTradeKrwDeposit (params?: {}): Promise<Dict>;
    privatePostTradeKrwWithdrawal (params?: {}): Promise<Dict>;
    privatePostTradeMarketBuy (params?: {}): Promise<Dict>;
    privatePostTradeMarketSell (params?: {}): Promise<Dict>;
    privatePostTradeStopLimit (params?: {}): Promise<Dict>;
    privatePostV2Orders (params?: {}): Promise<Dict>;
    privatePostV2OrdersBatch (params?: {}): Promise<Dict>;
    privatePostV2OrdersCancel (params?: {}): Promise<Dict>;
    privatePostV1Twap (params?: {}): Promise<Dict>;
    privatePostV1WithdrawsCoin (params?: {}): Promise<Dict>;
    privatePostV1WithdrawsKrw (params?: {}): Promise<Dict>;
    privatePostV1DepositsGenerateCoinAddress (params?: {}): Promise<Dict>;
    privatePostV1DepositsKrw (params?: {}): Promise<Dict>;
    privateDeleteV2Order (params?: {}): Promise<Dict>;
    privateDeleteV1Twap (params?: {}): Promise<Dict>;
    privateDeleteV1WithdrawsCoin (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
